export const SET_MEETING_TYPE = "SET_MEETING_TYPE";
export const DEFAULT_SELECTED_MEETING_TYPE = "";
export const ATTENDANCE_MEETING_TYPE_KEY = "attendance_selected_meeting_type";

const getInitialMeetingType = () => {
  try {
    return (
      localStorage.getItem(ATTENDANCE_MEETING_TYPE_KEY) ||
      DEFAULT_SELECTED_MEETING_TYPE
    );
  } catch (error) {
    return DEFAULT_SELECTED_MEETING_TYPE;
  }
};

const INITIAL_STATE = {
  selectedMeetingType: getInitialMeetingType(),
};

// eslint-disable-next-line default-param-last
const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_MEETING_TYPE:
      return { ...state, selectedMeetingType: action.payload.type };
    default:
      return { ...state };
  }
};

export default reducer;
